import http from '../../../utils/fetch';
export default {
    baseurl: '/api/swyl/v1/yonghu/',
    selecePage(query){
        return http({
            url: this.baseurl + '/bscCustomer/selectPage',
            method: 'post',
            params:query
        });
    },
    insert(query){
        return http({
            url: this.baseurl + '/bscCustomer/insert',
            method: 'post',
            data:query
        });
    },
    deleteById(v){
        return http.post('/api/swyl/v1/yonghu/bscCustomer/deleteById?id='+v);
    },
    selectById(v){
        return http.post('/api/swyl/v1/yonghu/bscCustomer/selectById?id='+v);
    },
    getAreaCity(v){
        return http.post('/api/swyl/v1/yonghu/bscCustagent/getAreaCity?area='+v);
    },
    seleceAgentPage(query){
        return http({
            url: this.baseurl + '/bscCustagent/selectPage',
            method: 'post',
            params:query
        });
    },
    insertAgent(query){
        return http({
            url: this.baseurl + '/bscCustagent/insert',
            method: 'post',
            data:query
        });
    },
    deleteAgentById(v){
        return http.post('/api/swyl/v1/yonghu/bscCustagent/deleteById?id='+v);
    },
    selectAgentById(v){
        return http.post('/api/swyl/v1/yonghu/bscCustagent/selectById?id='+v);
    }
}
